import React, {Component} from 'react';
import {ToastContainer} from "react-toastify";

export class InfoNotification extends Component {
    render() {
        return (
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
        )
    }
}